import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const VisitorAuthContext = createContext(null);

export function VisitorAuthProvider({ children }) {
  const [visitor, setVisitor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/visitor/me")
      .then((r) => setVisitor(r.data))
      .catch(() => setVisitor(false))
      .finally(() => setLoading(false));
  }, []);

  const signOut = async () => {
    await api.post("/auth/visitor/logout").catch(() => {});
    setVisitor(false);
  };

  return (
    <VisitorAuthContext.Provider value={{ visitor, loading, setVisitor, signOut }}>
      {children}
    </VisitorAuthContext.Provider>
  );
}

export const useVisitorAuth = () => useContext(VisitorAuthContext);
